import { all, put, fork, call, take } from "redux-saga/effects"
import { difference, every } from "lodash"

import CONFIG from "core/config"

import {
  GET_PARCELS,
  GET_PARCELS_REQUEST,
  GET_PARCELS_SUCCESS,
  GET_PARCELS_FAILURE,
  GET_PARCELS_CANCEL,
} from "data/constants"

import { get } from "data/fetch/parcels/list"

const getQueryString = trackingNumbers => trackingNumbers.map(t => `id=${t}`).join("&")
const getRedirectUrl = trackingNumbers => `${CONFIG.glopalRedirectUrl}/parcels?${getQueryString(trackingNumbers)}`

function* getParcels() {
  while (true) {
    const action = yield take(GET_PARCELS)
    yield put({ type: GET_PARCELS_REQUEST })
    try {
      const { data } = yield call(() => get(action.parcels))

      const found = data.items.map(item => item.tracking_number)
      const missing = difference(action.parcels, found)

      if (missing && missing.length === 0 && every(data.items, item => item.glopal_tracking_available)) {
        const redirectTo = getRedirectUrl(data.items.map(item => item.tracking_number))
        window.location.assign(redirectTo)
      }

      yield put({
        type: GET_PARCELS_SUCCESS,
        data: {
          ...data,
          errors: missing.map(n => ({
            tracking_number: n,
          })),
        },
      })
    } catch (error) {
      yield put({ type: GET_PARCELS_FAILURE, error })
    }
  }
}

export default function* main() {
  while (true) {
    const tasks = yield all([
      fork(getParcels),
    ])

    yield all(tasks)

    yield take(GET_PARCELS_CANCEL)
    yield tasks.map(task => task.cancel())
  }
}



// WEBPACK FOOTER //
// ./src/data/sagas/parcels/list.js